import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { BILLING, PREMIUM_BILLING } from '@/constants/pricingContent';
import { API_DAILY_LIMIT_PLUS_DISPLAY, API_DAILY_LIMIT_PREMIUM_DISPLAY, PLUS_MONTHLY_CREDITS_DISPLAY, PLUS_PREMIUM_MONTHLY_CREDITS_DISPLAY } from '@/constants/config';
import { ApiBody, ApiEyebrow, ApiLink, ApiSection, ApiTitle, useApiDesign } from './ApiEditorial';

const PLANS = [
  { name: 'Plus', price: BILLING, credits: PLUS_MONTHLY_CREDITS_DISPLAY, requests: API_DAILY_LIMIT_PLUS_DISPLAY, description: 'For your next idea.' },
  { name: 'Plus Premium', price: PREMIUM_BILLING, credits: PLUS_PREMIUM_MONTHLY_CREDITS_DISPLAY, requests: API_DAILY_LIMIT_PREMIUM_DISPLAY, description: 'More room to build.' },
];
function ApiPricing() {
  const { c, compact, mobile } = useApiDesign();
  return (
    <ApiSection label="API access and pricing">
      <View style={{ alignItems: 'center' }}>
        <ApiEyebrow>Start building</ApiEyebrow>
        <ApiTitle style={{ textAlign: 'center' }}>Great ideas start with access.</ApiTitle>
        <ApiBody style={{ textAlign: 'center', marginTop: 20, maxWidth: 590 }}>API access is included with Plus and Plus Premium. Choose your plan, create a key, and make your first request.</ApiBody>
      </View>
      <View style={{ flexDirection: mobile ? 'column' : 'row', gap: 20, marginTop: 40, width: '100%', maxWidth: 900, alignSelf: 'center' }}>
        {PLANS.map(plan => (
          <View key={plan.name} style={{ flex: mobile ? undefined : 1, minWidth: 0, padding: mobile ? 28 : 36, borderRadius: 24, backgroundColor: c.soft }}>
            <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 22, lineHeight: 30, letterSpacing: -0.5 }}>{plan.name}</Text>
            <Text style={{ color: c.secondary, fontSize: 14, lineHeight: 23, marginTop: 6 }}>{plan.description}</Text>
            <Text weight="semibold" style={{ color: c.ink, fontSize: compact ? 42 : 48, lineHeight: 58, letterSpacing: -2, marginTop: 26 }}>${plan.price.annualPerMonth}<Text style={{ color: c.secondary, fontSize: 13, letterSpacing: 0 }}> / month</Text></Text>
            <Text style={{ color: c.secondary, fontSize: 12, lineHeight: 21, marginTop: 6 }}>${plan.price.annualTotal} billed annually, or ${plan.price.monthly} billed monthly.</Text>
            <View style={{ borderTopWidth: 1, borderTopColor: c.rule, marginTop: 26, paddingTop: 23, gap: 10 }}>
              <Text style={{ color: c.ink, fontSize: 14, lineHeight: 23 }}>{plan.credits} credits per month</Text>
              <Text style={{ color: c.ink, fontSize: 14, lineHeight: 23 }}>{plan.requests} requests per day</Text>
              <Text style={{ color: c.ink, fontSize: 14, lineHeight: 23 }}>Access to every API model</Text>
            </View>
          </View>
        ))}
      </View>
      <ApiBody style={{ maxWidth: 740, alignSelf: 'center', textAlign: 'center', fontSize: 12, lineHeight: 21, marginTop: 24 }}>Requests use your credit balance, with a one-credit minimum. Daily limits apply alongside available credits. Chat and text are charged at provider cost plus a margin; media uses catalog pricing. Top-up credits never expire.</ApiBody>
      <View style={{ alignItems: 'center', paddingTop: 44, gap: 14 }}>
        <ApiLink primary href="/signup" style={{ alignSelf: 'center' }}>Get an API key</ApiLink>
        <ApiLink href="/pricing" style={{ alignSelf: 'center' }}>Compare all plans</ApiLink>
      </View>
    </ApiSection>
  );
}
export default React.memo(ApiPricing);
